import React from 'react';

import RangeSlider from '../../Default/RangeSlider';
import RadioButton from '../../Default/RadioButton';

export default function StaysDifferent({ updateBlokStateSettings, changesBack, changeBackTime }) {
    return (
        <div className="side-bar-page-content">
            <div className="side-bar-row">
                <RadioButton
                    name="changesBack"
                    value={false}
                    activeValue={changesBack}
                    onChange={() =>
                        updateBlokStateSettings({
                            changesBack: false
                        })
                    }
                >
                    Ik blijf anders
                </RadioButton>
                <RadioButton
                    name="changesBack"
                    value
                    activeValue={changesBack}
                    onChange={() =>
                        updateBlokStateSettings({
                            changesBack: true
                        })
                    }
                >
                    Ik word weer normaal na:
                </RadioButton>
                <RangeSlider
                    description={v => `${v}s`}
                    currentValue={changeBackTime}
                    min={0.1}
                    max={60}
                    step={0.1}
                    sliderStep={1}
                    precision={1}
                    disabled={!changesBack}
                    onChange={v =>
                        updateBlokStateSettings({
                            changeBackTime: v
                        })
                    }
                    valueOnSide
                />
            </div>
        </div>
    );
}
